"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandDownIcon = void 0;
var react_1 = __importDefault(require("react"));
var ExpandDown_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/ExpandDown"));
exports.ExpandDownIcon = (react_1.default.createElement(ExpandDown_1.default, { style: {
        fill: 'currentColor',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        fontSize: 'inherit',
        flexShrink: 0,
    } }));
